<template>
<div >
  <g-gantt-chart :chart-start="startDateGantt" @mousedown-bar="onMousedownBar($event.bar, $event.e, $event.datetime)"  :chart-end="EndDateGantt"  precision="month" grid width="100%" bar-start="beginDate" bar-end="endDate" date-format="DD.MM.YYYY HH:mm" color-scheme="vue" font="Courier" push-on-overlap>
    <g-gantt-row v-for="(row, index) in cropData" :key="index" :label="row.label" :bars="row.barsList" highlight-on-hover/>
  </g-gantt-chart>
</div>

</template>

<script>
export default {
  props:{
    cropData:Array
  },
  emits: ['activitySelected'],
  data() {
    return {
      rows:[]
    }
  },
  created(){
    // console.log(this.cropData)
  },
  methods:{
    onMousedownBar(a, b ,c){
      this.$emit('activitySelected',a)
    },
    formatDate(originalDate) {
      const date = new Date(originalDate);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getUTCHours().toString().padStart(2, '0');
      const minutes = date.getUTCMinutes().toString().padStart(2, '0');

      // Format the date in the desired string format
      const formattedDate = `${day}.${month}.${year} ${hours}:${minutes}`;
      return formattedDate; 
    },
  },
  computed:{
    startDateGantt(){
      let earliestStartDate = null;

      this.cropData.forEach(activity => {
        if (activity.barsList && activity.barsList.length > 0) {
          const activityStartDate = new Date(activity.barsList[0].activityStart);
          if (!earliestStartDate || activityStartDate < earliestStartDate) {
            earliestStartDate = activityStartDate;
          }
        }
      });

      if (earliestStartDate) {
        const bufferedDate = new Date(earliestStartDate);
        bufferedDate.setDate(bufferedDate.getDate() - 7);
        return this.formatDate(bufferedDate);
      }

      return this.formatDate(new Date());
    },
    EndDateGantt(){
      // Find the activity with the latest end date instead of hardcoding 'HV'
      let latestEndDate = null;
      
      this.cropData.forEach(activity => {
        if (activity.barsList && activity.barsList.length > 0) {
          const activityEndDate = new Date(activity.barsList[0].activityEnd);
          if (!latestEndDate || activityEndDate > latestEndDate) {
            latestEndDate = activityEndDate;
          }
        }
      });
      
      // Add 7 days buffer to the latest end date
      if (latestEndDate) {
        const bufferedDate = new Date(latestEndDate);
        bufferedDate.setDate(bufferedDate.getDate() + 7);
        return this.formatDate(bufferedDate);
      }
      
      // Fallback if no activities found
      return this.formatDate(new Date());
    }
  }

};
</script>

<style>
.g-gantt-bar{
  top: 8px !important;
  height: 21px !important;
}
</style>
